// @ts-nocheck
import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.element.style.height = "auto"
    this.element.style.height = this.element.scrollHeight + 5 + "px"
  }
}
